import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { MatLegacyCheckboxChange as MatCheckboxChange } from '@angular/material/legacy-checkbox';
import { BehaviorSubject } from 'rxjs';
import { Property } from '../../models/statements.models';

@Component({
  standalone: false,
  selector: 'sbnb-statements-property-picker',
  templateUrl: './sbnb-statements-property-picker.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StatementsPropertyPickerComponent implements OnChanges {
  @Input() properties: Property[] = [];
  @Input() selectedProperties: Property[] = [];
  @Input() disabledProperties: { id: number; reason: string }[] = [];

  @Output() selectedPropertiesChange = new EventEmitter<Property[]>();

  searchCriteria$: BehaviorSubject<string> = new BehaviorSubject<string>('');
  filteredProperties: Property[] = [];

  ngOnChanges(): void {
    this.searchCriteria$.subscribe((searchCriteria) => {
      if (searchCriteria && searchCriteria.length > 0) {
        this.filteredProperties = this.properties.filter((property) =>
          property.name.toLowerCase().includes(searchCriteria.toLowerCase())
        );
      } else {
        this.filteredProperties = this.properties;
      }
    });
  }

  isPropertySelected(property: Property): boolean {
    return this.selectedProperties.some((p) => p.id === property.id);
  }

  propertyCheckboxChange(property: Property, event: MatCheckboxChange) {
    if (event.checked) {
      this.selectedProperties.push(property);
    } else {
      this.selectedProperties = this.selectedProperties.filter((p) => p.id !== property.id);
    }

    this.selectedPropertiesChange.emit(this.selectedProperties);
  }

  allPropertiesChange(event: MatCheckboxChange) {
    if (event.checked) {
      // select all except disabled properties
      this.selectedProperties = this.properties.filter((property) => !this.isPropertyDisabled(property.id));
    } else {
      this.selectedProperties = [];
    }

    this.selectedPropertiesChange.emit(this.selectedProperties);
  }

  isPropertyDisabled(propertyId: number): boolean {
    return this.disabledProperties.some((dp) => dp.id === propertyId);
  }

  getDisabledReason(propertyId: number): string {
    return this.disabledProperties.find((dp) => dp.id === propertyId)?.reason;
  }
}
